import axios from "axios";
import { TOKEN } from "../config/localstorage_keys";
import { getLocalStorage, setLocalStorage } from "../redux/slices/storage";
import { handleApiResponseError } from "./apiErrorHandler";

// Standard API instance
const instance = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}`,
  timeout: 1000 * 60 * 10,
  headers: { "Content-Type": "application/json" },
  validateStatus: (status) => status >= 200 && status < 300,
});

// Local API instance for PDF/ODATA services
export const localApi = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL_ODATA_TUNNEL || "http://localhost:3333",
  timeout: 1000 * 60 * 10,
  headers: { "Content-Type": "application/json" },
  validateStatus: (status) => status >= 200 && status < 300,
});

const attachAuthInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getLocalStorage(TOKEN);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

attachAuthInterceptor(instance);

instance.interceptors.response.use(
  (res) => {
    if (
      res?.headers?.authorization &&
      typeof res.headers.authorization === "string" &&
      res.headers.authorization.length > 10
    ) {
      setLocalStorage(TOKEN, res.headers.authorization);
    }
    return res;
  },
  handleApiResponseError
);

localApi.interceptors.response.use((res) => res, handleApiResponseError);

export default instance;
